import { Divider } from "primereact/divider";

const CardBerangkatPulang = (props) => {
  const {
    judul,
    jumlahBerangkat,
    jumlahPulang,
    icon,
    bgColorTw,
    borderColorTw,
    textColorTw,
  } = props;
  return (
    <div
      className={`col-start-start bg-white shadow-md rounded-md p-3 border-l-4 ${borderColorTw} w-full min-[885px]:flex-grow`}
    >
      <div className="row-start-center gap-2 pb-5">
        <div
          className={`row-center-center ${bgColorTw} rounded-md w-[1.7rem] h-[1.7rem]`}
        >
          {icon}
        </div>
        <span className={`font-semibold ${textColorTw} tracking-wider`}>
          {" "}
          {judul}{" "}
        </span>
      </div>
      <div className="row-around-center w-full gap-6 px-2">
        <div className="col-center-center  ">
          <span className="text-slate-700 text-xl font-semibold">
            {jumlahBerangkat}
          </span>
          <span className="text-slate-700 text-sm ">Pergi</span>
        </div>
        <Divider className="m-0 h-[3rem]" layout="vertical" />
        <div className="col-center-center  ">
          <span className="text-slate-700 text-xl font-semibold">
            {jumlahPulang}
          </span>
          <span className="text-slate-700 text-sm ">Pulang</span>
        </div>
        <Divider className="m-0 h-[3rem]" layout="vertical" />
        <div className="col-center-center ">
          <span className="text-slate-700 text-xl font-semibold">
            {jumlahBerangkat - jumlahPulang}
          </span>
          <span className="text-slate-700 text-sm ">Di Jalan</span>
        </div>
      </div>
    </div>
  );
};

export default CardBerangkatPulang;
